// src/components/ResponsiveNavbar.jsx
import React, { useState, useEffect } from "react";
import DesktopNavbar from "./DesktopNavbar";
import MobileNavbar from "./MobileNavbar";

interface ResponsiveNavbarProps {
  onOpenEnquireModal: () => void;
  onOpenMobileEnquireModal: () => void;
}

const ResponsiveNavbar: React.FC<ResponsiveNavbarProps> = ({ onOpenEnquireModal,onOpenMobileEnquireModal }) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth <= 500
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 500);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isMobile ? <MobileNavbar onOpenEnquireModal={onOpenMobileEnquireModal}  /> : <DesktopNavbar onOpenEnquireModal={onOpenEnquireModal} />;
};

export default ResponsiveNavbar;
